import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import * as firebaseService from './services/firebase';
import { logger } from './logging';

// fixing parcel livereload with firebase hosting
if ((module as any).hot) {
  (module as any).hot.accept(() => {
    setTimeout(() => {
      return null;
    }, 300);
  });
}

logger.debug('index.tsx calling firebaseService.initialize()');
// initialize the default app
const damApp = firebaseService.getDAMApp();
// initialize the canopus app
firebaseService.getCanopusApp();
// initialize the ifb app
firebaseService.getIFBApp();
// initialize the party service app
firebaseService.getPartyServiceApp();
// initialize the addressbooks app
firebaseService.getAddressbooksApp();
// get firebase functions
const functions = getFunctions(damApp);

logger.info(`NODE_ENV: ${process.env.NODE_ENV}`);
//logger.info(`Dam app: ${JSON.stringify(damApp)}`);

// tell firebase to use the cloud functions emulator (for onCall) if env is development
if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'testing') {
  connectFunctionsEmulator(functions, 'dd-account-management.local', 5001);
}

if (window.location.hostname !== process.env.HOST) {
  logger.info(
    `window.location.hostname (${window.location.hostname}) is not equal to env.HOST (${process.env.HOST})`
  );
  if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'testing') {
    window.location.href = `http://${process.env.HOST}`;
  }

  window.location.href = `https://${process.env.HOST}`;
}

import 'bootstrap/dist/css/bootstrap.min.css';

import './global-styles.css';

import { App } from './App';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getEnvironmentBannerConfig } from './utils/environment';

/** Root-absolute href so Chrome does not re-resolve against nested SPA routes. */
const toRootAbsoluteHref = (path: string): string => {
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:') ||
    path.startsWith('/')
  ) {
    return path;
  }

  return `/${path}`;
};

const applyEnvironmentBranding = () => {
  const config = getEnvironmentBannerConfig();

  if (!config) {
    return;
  }

  const faviconLink = document.querySelector('link[rel="icon"]');

  if (faviconLink && typeof config.faviconPath === 'string') {
    faviconLink.setAttribute('href', toRootAbsoluteHref(config.faviconPath));
    faviconLink.setAttribute('type', 'image/svg+xml');
  }

  document.title = `Digital Accounts Management${config.titleSuffix}`;
};

applyEnvironmentBranding();

const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);

root.render(<App />);
